import { useEffect, useState } from "react";

export const PREORDER_STATUS_STORAGE_KEY = "preOrderReviewStatus";
const PREORDER_STATUS_CHANGE_EVENT = "preOrderStatusChange";

const getPreOrderStatusMap = () => {
  try {
    const raw = globalThis.localStorage.getItem(PREORDER_STATUS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error("Failed to read pre-order status:", error);
    return {};
  }
};

export const getStoredStatus = (orderId) => {
  const statusMap = getPreOrderStatusMap();
  return statusMap?.[orderId];
};

export const savePreOrderStatus = (orderId, status, details = {}) => {
  try {
    const statusMap = getPreOrderStatusMap();

    statusMap[orderId] = {
      status,
      ...details,
      date: new Date().toISOString(),
    };

    globalThis.localStorage.setItem(
      PREORDER_STATUS_STORAGE_KEY,
      JSON.stringify(statusMap)
    );
    globalThis.dispatchEvent(new Event(PREORDER_STATUS_CHANGE_EVENT));
  } catch (error) {
    console.error("Failed to save pre-order status:", error);
  }
};

export const usePreOrderStatus = (orderId) => {
  const [status, setStatus] = useState(() => getStoredStatus(orderId));

  useEffect(() => {
    setStatus(getStoredStatus(orderId));
    const handleChange = () => setStatus(getStoredStatus(orderId));
    globalThis.addEventListener(PREORDER_STATUS_CHANGE_EVENT, handleChange);
    return () =>
      globalThis.removeEventListener(
        PREORDER_STATUS_CHANGE_EVENT,
        handleChange
      );
  }, [orderId]);

  return status;
};

